import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Typography, FormGroup, Checkbox, Button, Popper} from 'views/components';
import {ArrowDropDown} from 'views/icons';

import {translate, Translate} from 'views/module';


{/* Logic and ui for selecting which correspondance type to view dropdown */}
const SelectCorrespondanceType = (props) => {
  const [open, setOpen] = React.useState(false);

  const anchorRef = React.useRef(null);

  const {
    corType,
    setCorType,
  } = props;

  const onCheckboxChange = (type) => {
    const newCorType = {...corType};
    newCorType[type] = !newCorType[type];
    setCorType(newCorType);
  };

  const onToggleDropDown = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const onClickAway = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        anchorref={anchorRef}
        variant='text'
        endIcon={<ArrowDropDown/>}
        onClick={onToggleDropDown}
        sx={{
          textTransform: 'none',
          fontSize: '12px',
          fontWeight: 500,
          color: '#484442',
          textAlign: 'right',
        }}
      >
        <Translate expression='clientLead.ClientLeadDetail.Correspondance.Filter'/>
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        onClickAway={onClickAway}
        GrowSx={{
          border: '1px solid rgba(0, 0, 0, 0.12)',
          borderRadius: '4px',
          boxSizing: 'border-box',
          boxShadow: '0px 3px 1px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
          pl: 1,
          py: 1,
        }}
      >
        <Grid container direction='column' spacing={0.5}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{fontWeight: 500}}>
              <Translate expression='clientLead.ClientLeadDetail.Correspondance.Filter'/>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormGroup sx={{pl: 2}}>
              <Checkbox
                label={translate('clientLead.ClientLeadDetail.Correspondance.Type.Comments')}
                checked={corType['COMMENTS']}
                onChange={() => onCheckboxChange('COMMENTS')}
              />
              <Checkbox
                label={translate('clientLead.ClientLeadDetail.Correspondance.Type.Announcements')}
                checked={corType['ANNOUNCEMENTS']}
                onChange={() => onCheckboxChange('ANNOUNCEMENTS')}
              />
              <Checkbox
                label={translate('clientLead.ClientLeadDetail.Correspondance.Type.Logs')}
                checked={corType['LOGS']}
                onChange={() => onCheckboxChange('LOGS')}
              />
            </FormGroup>
          </Grid>
        </Grid>
      </Popper>
    </>
  );
};
SelectCorrespondanceType.propTypes = {
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
  }).isRequired,
  setCorType: PropTypes.func.isRequired,
};

export default React.memo(SelectCorrespondanceType);
